import {setPosition} from "@/api/data";
import store from "@/store";


export const RandomNumBoth = (Min, Max) => {
    let Range = Max - Min;
    let Rand = Math.random();
    let num = Min + Math.round(Rand * Range);
    return num;
};

export const shareTitle = () => {
    const random = RandomNumBoth(0, 2);
    console.log(random);
    let rankArray1 = ["这个小封机器人送给你体验一下，记得还我", "我发现了一个非常好玩的资讯机器人，一起来试试！", "这是我见过最牛的资讯机器人了，强烈安利给你！"];
    let rankArray2 = ["有了他，每天的热门事件再也不会错过！他还可以陪你聊天，玩游戏解闷", "根本停不下来，他真的太懂我了！看新闻、玩游戏、聊八卦，啥都不耽误~", "根本停不下来，他真的太懂我了！看新闻、玩游戏、聊八卦，啥都不耽误~"];
    return {title: rankArray1[1], desc: rankArray2[1]};
};

export const insertStr = (soure, start, newStr) => {
    return soure.slice(0, start) + newStr + soure.slice(start);
};

export const parseData = (list, string) => {
    let array = [];
    for (let i = 0; i < list.length; i++) {
        if (list[i].indexOf(string) !== -1) {
            let tag = list[i].indexOf(string);
            let tag1 = "<span style=\"color: #1890ff\">".length;
            let flag1 = insertStr(list[i], tag, "<span style=\"color: #1890ff\">");
            let flag2 = insertStr(flag1, tag + string.length + tag1, "</span>");
            array.push(flag2);
        } else {
            array.push(list[i]);
        }
    }
    return array;
};


//解决ios点击空白区域键盘收回问题
export const objBlurFun = (device, sDom, time = 100) => {  //sDom, input / textarea 都可以。
    if (device == "ios") {  // 如果是ios环境下
        let obj = document.querySelector(sDom);   // 这里如果传入的是2个以上 需要用querySelectorAll() 同时
        objBlur(obj, time);                  //  需要遍历调用函数
    }
};
export const objBlur = (sDom, time = 100) => {
    if (sDom) {
        sDom.addEventListener("focus", () => {
                document.addEventListener("touchend", e => {   // 这里的e非常重要，用来判断是否是点击了input表单
                    docTouchend(time, sDom, e);
                });
            },
            false
        );
    }
};
// 元素失去焦点隐藏iphone的软键盘
export const docTouchend = (time, sDom, e) => {
    if (e.target != sDom && e.target.className.indexOf("themeBig") < 0) {     // 如果点击的是 屏幕空白处的情况下
        setTimeout(() => {
            sDom.blur();      // 表单失去焦点  键盘就会自动收起

            window.scroll(0, 0);
            document.removeEventListener("touchend", docTouchend, false);   // 收起之后 移除监听器
        }, time);
    } else {
    }
};

/*获取地理位置*/

export const getLocationPoint = () => {
    const obj = {};
    return new Promise((resolve, reject) => {
        try {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    obj.latitude = position.coords.latitude;//获取纬度
                    obj.longitude = position.coords.longitude;//获取经度
                    resolve(obj);
                }, () => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert("定位失败,用户拒绝请求地理定位");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("定位失败,位置信息是不可用");
                            break;
                        case error.TIMEOUT:
                            alert("定位失败,请求获取用户位置超时");
                            break;
                        case error.UNKNOWN_ERROR:
                            alert("定位失败,定位系统失效");
                            break;
                    }
                }, {
                    enableHighAccuracy: true,
                    timeout: 1000,
                    maximumAge: 1000
                });
            } else {
                alert("不支持定位功能");
            }
        } catch (e) {
            reject(e);
        }

    });
};

export const getBaiduLocation = () => {
    // 百度地图API功能
    console.info("百度地图API功能");
    let geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            setPosition({latitude: r.point.lat, longitude: r.point.lng});
        } else {
            setPosition({latitude: null, longitude: null});
            // alert('获取地理位置信息失败'+this.getStatus());
        }
    }, {enableHighAccuracy: true});
};


/* 判断字符串中是否包含某字符串 */
export const matchRegExps = (path, str) => {
    const regStr = new RegExp(path);
    return regStr.test(str);
};
export const createArray = (n,type) => {

//type :1 火   2：星星
    if (checkRate(n) && n <= 5) {

        let array = new Array(n).fill({});
        array.map((it, ix) => {
            it.star = type===2?'tiny':"star";
        });

        return array;
    } else {

        let array = new Array(Math.floor(n)).fill({});
        array.map((it, ix) => {
            it.star = type===2?'tiny':"star";
        });
        array.push({star: type===2?'tinyic':"starci"});
        return array;
    }

};

function checkRate(input) {
    let re = /^[1-9]+[0-9]*]*$/;   //判断字符串是否为数字     //判断正整数

    if (!re.test(input)) {
        return false;
    }
    return true;

}
